<template>
	<div class="ml-12">
		<!-- 导出按钮 -->
		<el-button class="export-btn" plain type="primary" @click="ExportFile">
			<img class="wh-14" src="@/assets/icon_12.png" alt="">
			<span class="ml-8 fz-14 lh-36">{{ text || translate.ShowText('导出') }}</span>
		</el-button>
	</div>
</template>

<script lang="ts" setup>
import { ref, getCurrentInstance, watch, onMounted } from 'vue';
import translate from '@/api/translate';

const props = defineProps({
	data: {
		type: Object,
		default: function () {
			return {}
		}
	},
	text: {
		type: String,
		default: ""
	}
});

watch(() => props.data.data, (n: any) => {
	list.value = n;
});

const { proxy } = getCurrentInstance() as any;
const loading = ref(false);
const list = ref([]);

onMounted(() => {
	if (props.data.data && props.data.data.length > 0) {
		list.value = props.data.data;
	}
});

const ExportFile = () => {
	if (!props.data.api) {
		proxy.$message.error("api链接不能为空");
		return false;
	}
	if (props.data.data && props.data.data.length == 0 && props.data.export_type == 1) {
		proxy.$message.error(props.data.ErrorTips);
		return false;
	}
	if (loading.value) {
		return false;
	}
	loading.value = true;
	let ids: any = [];
	list.value.forEach((v: any) => {
		ids.push(v.id);
	});
	proxy.$api.tokenRequest({
		url: props.data.api,
		method: "POST",
		isLoading: translate.ShowText('加载中...'), // 加载中...
		data: {
			type: props.data.type,
			export_type: props.data.export_type,
			ids: ids,
			params: props.data.params || {},
		},
		success: (res: any) => {
			loading.value = false;
			let a: any = document.createElement('a');
			a.href = res.data;
			a.setAttribute('download', translate.ShowText('导出模板')); // 导出模板
			a.click();
			a = null;
		},
		fail: () => {
			loading.value = false;
		},
	});
};
</script>

<style lang="scss" scoped>
.export-btn {
	padding: 0 15px;
	// width: 102px;
	height: 32px;
	border-radius: 4px;
	background: transparent;
	color: #0066FF;
}
</style>